import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TwitterColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M13.842 39.875c16.6 0 25.681-13.756 25.681-25.681 0-.387-.008-.782-.025-1.169A18.332 18.332 0 0 0 44 8.352a17.799 17.799 0 0 1-5.181 1.418 9.076 9.076 0 0 0 3.97-4.992 18.146 18.146 0 0 1-5.731 2.19A9.04 9.04 0 0 0 21.669 15.2 25.636 25.636 0 0 1 3.067 5.774 9.037 9.037 0 0 0 5.86 17.82a9.04 9.04 0 0 1-4.09-1.125v.111a9.024 9.024 0 0 0 7.243 8.852 8.972 8.972 0 0 1-4.072.154 9.044 9.044 0 0 0 8.428 6.274A18.105 18.105 0 0 1 0 35.821a25.609 25.609 0 0 0 13.842 4.054Z",
    svgColor: "#1DA1F2"
  }));
});
TwitterColor.displayName = 'TwitterColor';
TwitterColor.defaultProps = {
  'aria-label': 'TwitterColor'
};
export default TwitterColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/TwitterColor.js
// module id = 3590
// module chunks = 11